import { useTranslation } from 'react-i18next';

import { useAppSelector } from '@/hooks/redux-helpers';
import { COMPANY_MEMBERS_PER_PAGE } from '@/hooks/useDashboardConstants';

import { selectProfileByUserId } from '@/store/selectors';
import { useProfileContext } from '@/features/context/ProfileContext';
import { UserStatus } from '@/features/user/components/status/UserStatus';
import { UserStatusLabel, UserTypes } from '@/features/user/store/user.model';

export function useCompanyMembers() {
  const { user } = useProfileContext();
  const { t } = useTranslation();

  const members = useAppSelector((state) =>
    selectProfileByUserId(state, user.userId)?.state?.children?.state?.map((childState) => childState.state.user.state),
  );

  const maxItems = useAppSelector((state) => selectProfileByUserId(state, user.userId)?.state?.children?.maxItems);

  const { isLoading, error } =
    useAppSelector((state) => selectProfileByUserId(state, user.userId)?.state?.children) || {};

  const isPhysicalUser = user.userTypeId === UserTypes.naturalPerson;
  const pageTitle = isPhysicalUser
    ? t('pages.currentProfiles.profile.tabs.title.children')
    : t('pages.currentProfiles.profile.tabs.title.companyMembers');

  const hasAllItems = Number(maxItems) < COMPANY_MEMBERS_PER_PAGE;
  const statusOptions = Object.values(hasAllItems ? UserStatusLabel : UserStatus).map((status) => ({
    label: t(`pages.dashboard.users.status.${status}`),
    value: status,
  }));

  const totalRows = Number(members?.[0]?.totalRows || 0);

  return { statusOptions, totalRows, hasAllItems, user, pageTitle, isPhysicalUser, members, isLoading, error };
}
